import { debounce } from '@cian/ui-kit/internal/utils';
import { ECalculatorEventName, dispatchWidgetEvent } from '../../common/utils';
import { ECustomEventsDescriptions } from '../constants/customEventsDescriptions';

export const debouncedSubmitHandler = (eventTarget: HTMLFormElement | null) =>
  debounce((calcValues, currentErrors) => {
    if (Object.keys(currentErrors).length === 0 && eventTarget) {
      dispatchWidgetEvent(eventTarget, ECalculatorEventName.onSubmit, {
        description: ECustomEventsDescriptions.onSubmit,
        data: calcValues,
      });
    }
  }, 300);

export const debouncedErrorHandler = (eventTarget: HTMLFormElement | null) =>
  debounce(currentErrors => {
    if (Object.keys(currentErrors).length !== 0 && eventTarget) {
      dispatchWidgetEvent(eventTarget, ECalculatorEventName.onError, {
        description: ECustomEventsDescriptions.onError,
        data: currentErrors,
      });
    }
  }, 300);

export const debouncedClickMoreFiltersAnalyticsHandler = (eventTarget: HTMLButtonElement | null) =>
  debounce(() => {
    if (eventTarget) {
      dispatchWidgetEvent(eventTarget, ECalculatorEventName.onSendAnalytics, {
        description: ECustomEventsDescriptions.onAnalytics,
        data: { eventName: 'onClickMoreFilters' },
      });
    }
  }, 500);
